import { apiClient } from "../config";
import { env } from "../../config/env";

import {
  CreateOrderPayload,
  CreateOrderResponse,
  GetMyOrdersResponse,
  GetOrderResponse,
} from "../interface/orders.interface";

class OrderService {
  /**
   * 🛒 Créer une commande
   */
  async createOrder(
    payload: CreateOrderPayload
  ): Promise<CreateOrderResponse> {
    const response = await apiClient.post<CreateOrderResponse>(
      env.ORDERS.CREATE,
      payload
    );

    return response.data;
  }

  /**
   * 📦 Mes commandes
   */
  async getMyOrders(): Promise<GetMyOrdersResponse> {
    const response = await apiClient.get<GetMyOrdersResponse>(
      env.ORDERS.MY_ORDERS
    );

    return response.data;
  }

  /**
   * 📄 Détail commande
   */
  async getOrder(id: string): Promise<GetOrderResponse> {
    const response = await apiClient.get<GetOrderResponse>(
      env.ORDERS.SHOW(id)
    );

    return response.data;
  }

  // src/api/service/order.service.ts
async getLatestOrder(): Promise<GetOrderResponse> {
    const response = await apiClient.get<GetOrderResponse>(
        env.ORDERS.LATEST_ORDER // à définir dans env
    );
    return response.data;
}

}

export const orderService = new OrderService();